export default __webpack_public_path__ + "static/media/truck.1ad595eb.png";